import { Component, OnInit } from '@angular/core';
import { HomeService } from 'src/app/services/home.service';

@Component({
  selector: 'app-fullwidth',
  templateUrl: './fullwidth.component.html',
  styleUrls: ['./fullwidth.component.css']
})
export class FullwidthComponent implements OnInit {

  constructor(
    private homeService:HomeService
  ) { }

  ngOnInit() {
    this.homeService.getTranslate().then(result => {
      localStorage.setItem('local-translate', JSON.stringify(result))
    })
  }

}
